import { IconFunctionalInformationCircle16 } from '@cian/ui-kit/icons';
import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './PriceCorrectionHint.css';

export const PriceCorrectionHint: React.FC = () => {
  return (
    <div className={styles['hint']}>
      <IconFunctionalInformationCircle16 color="primary_100" />
      <UIText2 color="text-primary-default">Округляем цену, чтобы вы видели больше вариантов</UIText2>
    </div>
  );
};
